export var AdminThreatsTestSubjects;
(function (AdminThreatsTestSubjects) {
    AdminThreatsTestSubjects["UpdatedFeedSuccess"] = "UpdatedFeedSuccess";
    AdminThreatsTestSubjects["CreateFeedSuccess"] = "CreateFeedSuccess";
    AdminThreatsTestSubjects["DeleteFeedSuccess"] = "DeleteFeedSuccess";
    AdminThreatsTestSubjects["SyncFeedSuccess"] = "SyncFeedSuccess";
})(AdminThreatsTestSubjects || (AdminThreatsTestSubjects = {}));
export var AdminPipelinesTestSubjects;
(function (AdminPipelinesTestSubjects) {
    AdminPipelinesTestSubjects["PipelinesPage"] = "feeds-pipelines-page";
    AdminPipelinesTestSubjects["PipelinesTable"] = "feeds-pipelines";
})(AdminPipelinesTestSubjects || (AdminPipelinesTestSubjects = {}));
export var SiemAdminTabs;
(function (SiemAdminTabs) {
    SiemAdminTabs["Feeds"] = "admin.siem.feeds";
    SiemAdminTabs["Pipelines"] = "admin.siem.pipelines";
    SiemAdminTabs["Content"] = "admin.siem.content";
})(SiemAdminTabs || (SiemAdminTabs = {}));
export var AdminPage;
(function (AdminPage) {
    AdminPage["Users"] = "USERS";
    AdminPage["Insights"] = "INSIGHTS";
    AdminPage["Rates"] = "RATES";
    AdminPage["Notifications"] = "NOTIFICATIONS";
    AdminPage["Sawmill"] = "SAWMILL";
    AdminPage["Metrics"] = "METRICS";
    AdminPage["Siem"] = "SIEM";
})(AdminPage || (AdminPage = {}));
//# sourceMappingURL=admin.enum.js.map